export function fireMetaTrackLeadEvent() {
  if (typeof window === "undefined") return
  if (typeof window.fbq !== "function") return

  window.fbq("track", "Lead")
}
